import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ParkingService } from '@shared/components/parking-lot/services/parking.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SafeHtml } from '@angular/platform-browser';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-super-admin-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  termsAndCondition: SafeHtml;
  termAndConditionFilePath: string;
  currentBookingType: string;

  constructor(private readonly ref: DynamicDialogRef,  public readonly config: DynamicDialogConfig, private readonly parkingService: ParkingService) { }

  ngOnInit(): void {
    this.termsAndCondition = this.config.data.termAndCondition;
    this.termAndConditionFilePath = this.config?.data?.termAndConditionFilePath;
    this.currentBookingType = this.config?.data?.bookingType;
  }

  closeDialog() {
    this.ref.close();
  }

  getParkingLocationById(id: string) {
    this.parkingService.getParkingLotsById(id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe((res) => {
      this.termsAndCondition = res.termsAndCondition;
    })
  }
}
